import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from "html-react-parser";
import { services } from "constants/services";
import { AccordionGeneral } from "components/accordion";
import atm_fees from "assets/images/table/atm_fees.png";

import Others from "assets/images/hero-images/Banner_Others.png";
import BG from "assets/images/hero-images/BG.png";

function ATMServices() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Services"
          title={`<span className="jumbotron-subtitle-2">ATM</span> Services`}
          backgroundImage={Others}
          uniqueBg={BG}
        />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{services.atm.about.title}</h2>
            </Col>
            <Col md={8}>{parse(services.atm.about.description)}</Col>
          </Row>
          <Row className="my-5">
            <Col>
              <AccordionGeneral list={services.atm.accordion} />
            </Col>
          </Row>
          <Row className="py-5">
            <Col>
              <h3>Fees & Charges</h3>
              <br />
              <img src={atm_fees} alt="atm_fees" className="responsive-img" />
            </Col>
          </Row>
          <Row className="my-5 pb-5">
            <Col md={4}>
              <h2>{services.atm.importantNotice.title}</h2>
            </Col>
            <Col md={8}>{parse(services.atm.importantNotice.description)}</Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default ATMServices;
